import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { Modal, Button } from "antd";
import AdditionalEvaluationResultForm from "./AdditionalEvaluationResultForm";
import { FormComponentProps } from "antd/lib/form";

export interface State {}

export interface AdditionalEvaluationResultModalProps
  extends FormComponentProps {
  translate: TTranslate;
  visible?: boolean;
  updateResult(resut: string): void;
  onCancel(): void;
  result?: string;
}

export default class AdditionalEvaluationResultModal extends React.Component<
  AdditionalEvaluationResultModalProps,
  State
> {
  render() {
    const { translate, visible, updateResult, onCancel, result } = this.props;

    const { getFieldDecorator } = this.props.form;

    const onSubmit = () => {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const result = values.result;
          updateResult(result);
        }
      });
    };

    return (
      <Modal
        title={translate("additional_evaluation_modal.title")}
        visible={visible || false}
        onCancel={onCancel}
        maskClosable={false}
        onOk={() => onSubmit()}
        footer={[
          <Button key="back" onClick={onCancel}>
            {translate("additional_evaluation_moda.cancel")}
          </Button>,
          <Button key="submit" type={"primary"} onClick={() => onSubmit()}>
            {translate("additional_evaluation_moda.submit")}
          </Button>
        ]}
      >
        <AdditionalEvaluationResultForm
          translate={translate}
          result={result || ""}
          getFieldDecorator={getFieldDecorator}
        />
      </Modal>
    );
  }
}
